<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead :title="'Operator Hotels'"></cardHead>
      <loadArea v-if="countries == null || operators == null"></loadArea>
      <div class="row m-0" v-if="countries != null && operators != null">
        <div class="col-md-8 p-10">
          <Form
            method="dialog"
            v-slot="{ errors }"
            class="floating-labels row"
            ref="form"
          >
            <div class="col">
              <formGroup
                :title="'CountryId'"
                :as="'select'"
                :disabled="countries.length == 0"
                v-model="filter.CountryId"
                :errors="errors"
                @keydown.enter="save"
              >
                <template #input>
                  <option :value="null"></option>
                  <option
                    v-for="item in countries"
                    :value="item.Id"
                    :key="item.Id"
                    >{{ item.Name }}</option
                  >
                </template>
              </formGroup>
            </div>
            <div class="col">
              <formGroup
                :title="'OperatorId'"
                :as="'select'"
                :disabled="operators.length == 0"
                v-model="filter.OperatorId"
                :errors="errors"
                @keydown.enter="save"
              >
                <template #input>
                  <option :value="null"></option>
                  <option
                    v-for="item in operators"
                    :value="item.Id"
                    :key="item.Id"
                    >{{ item.Name }}</option
                  >
                </template>
              </formGroup>
            </div>
            <div class="col-auto">
              <Btn
                class="btn-success"
                @click="get()"
                :disabled="process"
                :process="process"
                >Get</Btn
              >
            </div>
          </Form>
          <dataTable
            :name="'TourScopeOperatorHotels'"
            ref="agGrid"
            :columnDefs="columnDefs"
            :data="data"
            @unMatch="unMatch($event)"
            @cellClicked="
              select = $event?.data;
              model.OperatorHotelId = select.Id;
              match();
            "
            :rowClassRules="{
              // row style function
              success: (params) => {
                // var numSickDays = params.data;
                return params?.data?.HotelId != null;
              },
              rowClass: (params, select) => {
                // var numSickDays = params.data;
                return params?.data?.Id == select || select == undefined;
              },
            }"
          ></dataTable>
        </div>
        <div class="col-md-4 p-t-0 p-10 border-left">
          <hotels
            :selectMain="select == null ? null : select"
            @selectHotel="
              model.HotelId = $event.Id;
              match();
            "
            :countryId="hotelCountryId"
          ></hotels>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hotels from "./hotels";
export default {
  name: "OperatorHotels",
  components: { hotels },
  data() {
    return {
      process: false,
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "Id",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        // { headerName: "OperatorId", width:140, filter: 'agNumberColumnFilter', field: "OperatorId", sortable:true, cellClick:true,},
        {
          headerName: "Name",
          filter: "agTextColumnFilter",
          field: "Name",
          flex: 3,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Country",
          filter: "agTextColumnFilter",
          field: "Name2",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        }, //, rowGroup:true, hide:true},
        // { headerName: "Operator", filter: 'agTextColumnFilter',field: "Name1", flex: 1, sortable:true, cellClick:true , enableRowGroup: true},//, rowGroup:true, hide:true},
        {
          headerName: "Region",
          filter: "agTextColumnFilter",
          field: "Region",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        }, //, rowGroup:true, hide:true},
        {
          headerName: "Star",
          filter: "agTextColumnFilter",
          field: "Star",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        }, //, rowGroup:true, hide:true},
        {
          headerName: "Hotel",
          filter: "agTextColumnFilter",
          field: "Name3",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Code1",
          filter: "agTextColumnFilter",
          field: "Code1",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Code2",
          filter: "agTextColumnFilter",
          field: "Code2",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "",
          type: "action",
          width: 40,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-danger",
              text: '<i class="far fa-times-circle"></i>',
              emit: "unMatch",
              if: (data) => {
                return data.HotelId != null;
              },
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
        },
      ],
      data: null,
      select: null,
      countries: null,
      operators: null,
      filter: {
        CountryId: 228,
        OperatorId: 1,
      },
      hotelCountryId: 228,
      model: {
        OperatorHotelId: this.select?.Id,
        HotelId: null,
      },
    };
  },
  watch: {
    select() {
      if (this.select != undefined && this.select != null) {
        this.$refs.agGrid.selectRow([this.select.Id]);
      } else {
        this.$refs.agGrid.selectRow([]);
      }
    },
  },
  created() {
    this.get();
    this.$appAxiosAdmin.get(`Countries`).then((response) => {
      this.countries = response.data;
    });
    this.$appAxiosAdmin.get(`OperatorsNames`).then((response) => {
      this.operators = response.data;
    });
  },
  methods: {
    get() {
      this.process = true;
      this.data = null;
      this.hotelCountryId = this.filter.CountryId;
      this.$appAxiosAdmin
        .get(
          `tourscope/OperatorHotels?OperatorId=` +
            this.filter.OperatorId +
            `&CountryId=` +
            this.filter.CountryId
        )
        .then((response) => {
          this.data = response.data.sort((x) => (x.HotelId == null ? -1 : 2));
          this.process = false;
        });
    },
    match() {
      var model = { ...this.model };
      if (
        model.OperatorHotelId != undefined &&
        model.OperatorHotelId != null &&
        model.HotelId != undefined &&
        model.HotelId != null
      ) {
        this.$appAxiosAdmin
          .post(`TOURSCOPE/OperatorHotels/Match`, model)
          .then(() => {
            this.select = null;
            this.$appAxiosAdmin
              .get(
                `tourscope/OperatorHotels?OperatorHotelId=` +
                  model.OperatorHotelId
              )
              .then((response) => {
                this.model = {
                  OperatorHotelId: this.select?.Id,
                  HotelId: null,
                };
                this.$refs.agGrid.changeRow("Id", response.data[0]);
              });
          })
          .catch((err) => {
            this.$isError(err);
          });
      }
    },
    unMatch(item) {
      this.$swal({
        icon: "question",
        title: "Warning",
        text: "Do you want to cancel the mapping of  " + item.Name + "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .get(`TOURSCOPE/OperatorHotels/Unmatch/` + item.Id)
            .then(() => {
              this.$refs.agGrid.changeRow("Id", {
                ...item,
                HotelId: null,
                Name3: null,
              });
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The hotel match has been cancelled.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              this.$appAxiosAdmin
                .get(`tourscope/OperatorHotels/` + item.Id)
                .then((response) => {
                  this.$refs.agGrid.changeRow("Id", response.data[0]);
                });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
  computed: {},
};
</script>
<style>
.floating-labels.row {
  margin: 0 -5px;
}
.floating-labels.row > div {
  padding: 0 5px;
}
</style>
